const removeParam = (searchQuery: string, paramToRemove: string): string => {
  const searchParams = new URLSearchParams(searchQuery);
  searchParams.delete(paramToRemove);
  return searchParams.toString();
};

export default removeParam;
